/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useContext, useMemo, useState } from 'react';
import { EComponentType, } from './types';
const store = createContext({
    state: {},
    setState: () => null,
});
const { Provider } = store;
const AppSettingsProvider = (props) => {
    const { environment } = props;
    const [state, setState] = useState(environment);
    return React.createElement(Provider, { value: { state, setState } }, props.children);
};
function useAppSettings() {
    const settingsContext = useContext(store);
    const settings = useMemo(() => {
        return settingsContext.state;
    }, [settingsContext.state]);
    return {
        isIonic: settings && settings['componentType'] === EComponentType.Ionic,
        isWeb: settings && settings['componentType'] === EComponentType.Web,
        setState: settingsContext.setState,
        settings: settings,
    };
}
export { store as AppSettingsStore, AppSettingsProvider, useAppSettings };
//# sourceMappingURL=provider.js.map